import { g, Tool } from '@hcie/core';
import { EventBus } from '@hcie/shared';

export function initVectorSelectCoordinator() {
    EventBus.on('CANVAS_MOUSE_DOWN', () => {
        if (g.current_tool.id !== Tool.VectorSelect.id) return;
        const vtm = (window as any).vectorToolManager;
        if (!vtm || typeof vtm.trySelectShapeAt !== 'function') return;
        vtm.trySelectShapeAt(g.pX, g.pY, g.activeLayerIndex);
    });
}

